import noonConfig from '../../noon/noonConfig';
import dailyConfig from '../../noon/dailyConfig';
import kulConfig from '../../kul/kulConfig';
import sivviConfig from '../../sivvi/sivviConfig';

import { MARKETPLACE, APP } from '../baseConfig';

import { TAppConfig, TMarketplace, TMarketplaceConfig } from '../types/config';

let memoizedAppConfig: TAppConfig | null = null;

const MARKETPLACE_CONFIGS: { [TConfig in TMarketplace]: TMarketplaceConfig } = {
    noon: noonConfig,
    kul: kulConfig,
    sivvi: sivviConfig,
    daily: dailyConfig,
};

// #TODO: This is a hack, we need to find a cleaner way to do this
export const MARKETPLACE_CONFIG =
    APP === 'daily-bigalog' || APP === 'daily-schmatalog' ? dailyConfig : MARKETPLACE_CONFIGS[MARKETPLACE];

export const getAppConfig = async (): Promise<TAppConfig> => {
    if (memoizedAppConfig) {
        return memoizedAppConfig;
    }
    // eslint-disable-next-line no-underscore-dangle
    const importedAppConfig = await import(`../../../${process.env._MARKETPLACE}-${process.env._APP}/appConfig`);
    ({ default: memoizedAppConfig } = importedAppConfig);
    return memoizedAppConfig as TAppConfig;
};

export const getMarketplaceConfig = (marketplace: TMarketplace): TMarketplaceConfig => MARKETPLACE_CONFIGS[marketplace];
